import React from "react";
import { LookupOrdersByEmailBody } from "tsi-common-react/src/apps/customer-account/LookupOrdersByEmailBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LookupOrdersByEmailDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <LookupOrdersByEmailBody {...props} />
    </PageSkeleton>
);
